import { Model } from "..";

export default class SocialIcon extends Model {
  name!: string;
  url!: string;
}
